<template>
  <div>
    <b-modal
      id="modal-prevent-closing-deposit"
      ref="modal-deposit"
      v-model="showModal"
      hide-footer
      centered
    >
      <template #modal-title> Buy Plan </template>
      <validation-observer ref="deposit">
        <div class="p-1">
          <h4 class="font-weight-normal">
            You selected {{ plan.name }} plan .
          </h4>
          <h4 class="font-weight-normal">total price {{ plan.fee }}$</h4>
        </div>

        <b-form class="auth-add-user-form my-2" @submit.prevent="deposit">
          <b-form-group
            label-for="type"
            class="w-100"
            label="Choose a payment method"
          >
            <b-row>
              <b-col
                class="d-flex"
                md="4"
                cols="6"
                v-for="(item, index) in types"
                :key="index"
              >
                <div
                  @click="
                    type = item.value;
                    currency = item.currency ? item.currency : '';
                  "
                  :class="`shadow-lg rounded ${
                    type == item.value ? 'border-warning' : 'border'
                  } cursor-pointer d-flex align-items-center justify-content-center w-100 my-50 p-1`"
                  style="height: 80px"
                >
                  <b-badge
                    v-if="type == item.value"
                    variant="warning"
                    class="rounded-circle p-25"
                    style="position: absolute; top: -15px; right: 20px"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      style="width: 12px; height: 12px"
                    />
                  </b-badge>
                  <b-img
                    :alt="item.title"
                    :src="item.img"
                    fluid
                    style="max-height: 40px"
                  />
                </div>
              </b-col>
              <b-col class="d-flex" cols="12">
                <div
                  @click="
                    type = crypto.value;
                    currency = crypto.currency ? crypto.currency : '';
                  "
                  :class="`shadow-lg rounded ${
                    type == crypto.value ? 'border-warning' : 'border'
                  } cursor-pointer d-flex align-items-center justify-content-center w-100 my-50 p-1`"
                  style="height: 80px"
                >
                  <b-badge
                    v-if="type == crypto.value"
                    variant="warning"
                    class="rounded-circle p-25"
                    style="position: absolute; top: -15px; right: 20px"
                  >
                    <feather-icon
                      icon="CheckIcon"
                      style="width: 12px; height: 12px"
                    />
                  </b-badge>
                  <h3>
                    {{ crypto.title }}
                  </h3>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
          <b-button variant="primary" block type="submit" class="my-1">
            Buy
          </b-button>
        </b-form>
      </validation-observer>
      <loader :loading="loading" />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BBadge,
  BCol,
  BLink,
  BButtonGroup,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BModal,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";

import VueSweetalert from "vue-sweetalert2";

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButtonGroup,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BModal,
    Loader,
    BBadge,
    VueSweetalert,
  },
  data() {
    return {
      currentBalance: "",
      customPrice: "",
      amount: "",
      type: "STRIPE1",
      currency: "",
      crypto: {
        value: "NOW_PAYMENT1",
        title: "Pay with crypto",
        currency: "usdt",
      },
      types: [
        {
          value: "STRIPE1",
          title: "master card",
          img: require("@/assets/images/fxlegends/MasterCard-Logo-1990.png"),
        },
        {
          value: "STRIPE2",
          title: "visa card",
          img: require("@/assets/images/fxlegends/Visa_Inc._logo.svg.png"),
        },
        {
          value: "STRIPE3",
          title: "debit card",
          img: require("@/assets/images/fxlegends/debit.png"),
        },
        // {
        //   value: "NOW_PAYMENT1",
        //   title: "tether",
        //   img: require("@/assets/images/fxlegends/tether-1.svg"),
        //   currency: "usdt",
        // },
        // {
        //   value: "NOW_PAYMENT2",
        //   title: "btc",
        //   img: require("@/assets/images/fxlegends/btc1.png"),
        //   currency: "btc",
        // },
        // {
        //   value: "NOW_PAYMENT3",
        //   title: "etc",
        //   img: require("@/assets/images/fxlegends/etc.png"),
        //   currency: "etc",
        // },
      ],
      loading: false,
      required,
    };
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },
  props: {
    plan: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deposit() {
      this.$refs.deposit.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            let pay = {
              type: this.type.includes("STRIPE") ? "STRIPE" : "NOW_PAYMENT",
            };
            !this.type.includes("STRIPE") && (pay.currency = this.currency);
            const { data } = await this.$http.post(
              `/panel/plans/${this.plan.id}/subscribe`,
              { ...pay }
            );
            window.location.assign(data.payment.url);
          } catch (err) {}
          this.loading = false;
          // this.$swal("Your payment has been successfully completed", 'OK');
          this.showModal = false;
          // this.$router.push("/partner-registration/step2").catch((err) => {});
        }
      });
    },
  },
};
</script>
